import InnovationActions from "../actions/innovationActions";

const InnovationReducer = (state = {
  isInnovationLoading: false, innovationHasError: false,
  isGetInnovationByIdLoading: false, getInnovationByIdHasError: false,
  updateInnovationLoading: false, updateInnovationHasError: false,
  isInnovationListLoading: false, InnovationListHasError: false,
  innovationVolumeIsLoading: false, innovationVolumeHasError: false,
  deleteInnovationIsLoading: false, deleteInnovationHasError: false,
  regionChannelSplitIsLoading: false, regionChannelSplitHasError: false,
  submittingRegionChannelSplitIsLoading: false, submittingRegionChannelSplitHasError: false
}, action) => {
  switch (action.type) {
    case InnovationActions.INNOVATION_REQUEST:
      return {
        ...state,
        isInnovationLoading: true,
        innovationHasError: false,
        innovation: null
      };
    case InnovationActions.INNOVATION_SUCCESSFUL:
      return {
        ...state,
        isInnovationLoading: false,
        innovation: action.data,
        innovationHasError: false
      };
    case InnovationActions.INNOVATION_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        innovation: null,
        isInnovationLoading: false,
        innovationHasError: true
      };


    //********** GET INNOVATION FROM ID ***********
    case InnovationActions.GET_INNOVATION_BY_ID_REQUEST:
      return {
        ...state,
        isGetInnovationByIdLoading: true,
        getInnovationByIdHasError: false,
        innovationById: null
      };
    case InnovationActions.GET_INNOVATION_BY_ID_SUCCESSFUL:
      return {
        ...state,
        isGetInnovationByIdLoading: false,
        innovationById: action.data,
        getInnovationByIdHasError: false
      };
    case InnovationActions.GET_INNOVATION_BY_ID_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        innovationById: null,
        isGetInnovationByIdLoading: false,
        getInnovationByIdHasError: true
      };


    //********** UPDATE INNOVATION ***********
    case InnovationActions.UPDATE_INNOVATION_REQUEST:
      return {
        ...state,
        updateInnovationLoading: true,
        updateInnovationHasError: false,
        updateInnovation: null
      };
    case InnovationActions.UPDATE_INNOVATION_SUCCESSFUL:
      return {
        ...state,
        updateInnovationLoading: false,
        updateInnovation: action.data,
        updateInnovationHasError: false
      };
    case InnovationActions.UPDATE_INNOVATION_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        updateInnovation: null,
        updateInnovationLoading: false,
        updateInnovationHasError: true
      };


    //********** GET INNOVATION LIST ***********
    case InnovationActions.GET_INNOVATION_LIST_REQUEST:
      return {
        ...state,
        isInnovationListLoading: true,
        InnovationListHasError: false,
        innovationList: null
      };
    case InnovationActions.GET_INNOVATION_LIST_SUCCESSFUL:
      return {
        ...state,
        isInnovationListLoading: false,
        innovationList: action.data,
        InnovationListHasError: false
      };
    case InnovationActions.GET_INNOVATION_LIST_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        innovationList: null,
        isInnovationListLoading: false,
        InnovationListHasError: true
      };


    //********** POST INNOVATION ***********
    case InnovationActions.POST_INNOVATION_VOLUME_REQUEST:
      return {
        ...state,
        innovationVolumeIsLoading: true,
        innovationVolumeHasError: false,
        innovationVolume: null
      };
    case InnovationActions.POST_INNOVATION_VOLUME_SUCCESS:
      return {
        ...state,
        innovationVolumeIsLoading: false,
        innovationVolume: action.data,
        innovationVolumeHasError: false
      };
    case InnovationActions.POST_INNOVATION_VOLUME_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        innovationVolume: null,
        innovationVolumeIsLoading: false,
        innovationVolumeHasError: true
      };


    //********** DELETE INNOVATION ***********
    case InnovationActions.DELETE_INNOVATION_REQUEST:
      return {
        ...state,
        deleteInnovationIsLoading: true,
        deleteInnovationHasError: false,
        deleteInnovation: null
      };
    case InnovationActions.DELETE_INNOVATION_SUCCESS:
      return {
        ...state,
        deleteInnovationIsLoading: false,
        deleteInnovation: action.data,
        deleteInnovationHasError: false
      };
    case InnovationActions.DELETE_INNOVATION_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        deleteInnovation: null,
        deleteInnovationIsLoading: false,
        deleteInnovationHasError: true
      };


    //********** GET REGION CHANNEL SPLIT ***********
    case InnovationActions.GET_REGION_CHANNEL_SPLIT_REQUEST:
      return {
        ...state,
        regionChannelSplitIsLoading: true,
        regionChannelSplitHasError: false,
        regionChannelSplit: null
      };
    case InnovationActions.GET_REGION_CHANNEL_SPLIT_SUCCESS:
      return {
        ...state,
        regionChannelSplitIsLoading: false,
        regionChannelSplit: action.data,
        regionChannelSplitHasError: false
      };
    case InnovationActions.GET_REGION_CHANNEL_SPLIT_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        regionChannelSplit: null,
        regionChannelSplitIsLoading: false,
        regionChannelSplitHasError: true
      };


    //********** POST REGION CHANNEL SPLIT ***********
    case InnovationActions.POST_REGION_CHANNEL_SPLIT_REQUEST:
      return {
        ...state,
        submittingRegionChannelSplitIsLoading: true,
        submittingRegionChannelSplitHasError: false,
        submittingRegionChannelSplit: null
      };
    case InnovationActions.POST_REGION_CHANNEL_SPLIT_SUCCESS:
      return {
        ...state,
        submittingRegionChannelSplitIsLoading: false,
        submittingRegionChannelSplit: action.data,
        submittingRegionChannelSplitHasError: false
      };
    case InnovationActions.POST_REGION_CHANNEL_SPLIT_FAILED:
      return {
        ...state,
        errorMessage: action.error,
        submittingRegionChannelSplit: null,
        submittingRegionChannelSplitIsLoading: false,
        submittingRegionChannelSplitHasError: true
      };
    default:
      return {
        ...state
      };
    //   break;
  }
};

export default InnovationReducer;
